import { ICompany } from './company.interface';

export interface IReferenceConfig {
  id: number;
  companyCode: string;
  company: ICompany;
}
